import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex } from "@chakra-ui/react";
import { Form, FormikProvider } from "formik";
import { trackFooter as track } from "~/events";
import { useNewsletterForm } from "~/hooks/useNewsletterForm";
import { TextInput } from "../TextInput";
import { NewsletterFormConfirmation } from "./NewsletterFormConfirmation";

export const NewsletterForm: FC = () => {
  const { formik, hasSubmitted } = useNewsletterForm();
  const { t } = useTranslation();

  return (
    <Flex align="center" direction="column" w="100%">
      <FormikProvider value={formik}>
        <Form style={{ maxWidth: "23rem", width: "100%" }}>
          {hasSubmitted ? (
            <NewsletterFormConfirmation />
          ) : (
            <Flex direction="column" gap={4}>
              <TextInput
                label="Email"
                labelProps={{ color: "on-accent" }}
                minH="unset"
                name="email"
                type="email"
              />
              <Button
                isLoading={formik.isSubmitting}
                onClick={track.newsletterForm}
                type="submit"
                variant="secondary-new"
                w="full"
              >
                {t("newsletterForm.cta")}
              </Button>
            </Flex>
          )}
        </Form>
      </FormikProvider>
    </Flex>
  );
};
